import { DocumentationFirst } from './DocumentationFirst';
import { DocumentationSecond } from './DocumentationSecond';
import { DocumentationThird } from './DocumentaionThird';
import { useQuery } from '@tanstack/react-query';
import { getCustomerFormFields, getOrderConfirmationFn } from '../../../transactions/orders/orders';
import { useParams } from 'react-router-dom';
import { useState } from 'react';


export const Documentation = ({ onDocumentationComplete, customerCode, currentStep, setCurrentStep, state, isKYC, newCustomerForm }) => {
  const { orderId } = useParams();
  const [isLoading, setIsLoading] = useState(false)

  const { data: fields} = useQuery({
    queryKey: [customerCode,'customerFields'],
    queryFn: () => getCustomerFormFields(customerCode),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: customerCode !== undefined && currentStep === 2
  });


  return (
    <div className="lg:left-[400px] pt-10 absolute top-0 w-full lg:w-[calc(100vw-500px)] max-lg:p-2 max-lg:pb-[130px]">
      {currentStep === 2 && fields &&  fields.data &&  (
        <DocumentationFirst
          message={state.message}
          isKYC={isKYC}
          newCustomerForm={newCustomerForm}
          fields={fields.data.requiredFields}
          setCurrentStep={setCurrentStep}
        />
      )}
      {currentStep === 3 && (
        <DocumentationSecond
          message={state.message}
          onStepCompleted={() => {
            setIsLoading(true)
            getOrderConfirmationFn(orderId).then((data) => {setCurrentStep(4); setIsLoading(false)})
            }}
          isLoading={isLoading}
        />
      )}
      {(currentStep === 4 || currentStep === 5 ) && (
        <DocumentationThird
          onStepCompleted={onDocumentationComplete}
          state={state}
          currentStep={currentStep}
        />
      )}
    </div>
  );
};
